/*
  Used to map parse data in TableFilter,
  because a field could be has 2 operations
*/

const parseFilterDataMapping = {
  created_on: ['created_on:gte', 'created_on:lte'],
  load_weight_min: 'load_weight:gte',
  load_weight_max: 'load_weight:lte',
  load_volume_min: 'load_volume:gte',
  load_volume_max: 'load_volume:lte',
  load_min_temperature: 'load_min_temperature:gte',
  load_max_temperature: 'load_max_temperature:lte',
  shipped_customer_id: 'shipped_customer.id:in',
  billed_customer_id: 'billed_customer.id:in',
  vendor_id: 'vendor.id:in',
  origin_address_id: 'origin_address.id:in',
  destination_address_id: 'destination_address.id:in',
  shipment_type: 'shipment_type',
  user_group_id: 'user_group.id:in',
  product_category: 'product_category.id:in',
  expected_delivered_on: ['expected_delivered_on:gte', 'expected_delivered_on:lte'],
  line_order: 'line_order',
}

export default parseFilterDataMapping
